// extracted by mini-css-extract-plugin
module.exports = {"Content":"VideoFull_Content__NMgaj","Buttons":"VideoFull_Buttons__VdwWe","Social":"VideoFull_Social__RtgEd"};